import React, {useState} from "react";
import {Card} from "../../../../../components/card/card.jsx";
import ChatHistory from "../../../../../components/chat/chat-history.jsx";
import AttendanceService from "../../../../../services/dispatch/attendance-service.js";

const AttendanceChatCard = ({id, show}) => {
    const [status, setStatus] = useState(null);

    if (!id || !show || status === "NOT_FOUND") return null;

    return (
        <Card>
            <Card.Header>
                <Card.Title>Chat do atendimento</Card.Title>
            </Card.Header>
            <Card.Body className="flex justify-center">
                <div className="w-full max-w-[900px]">
                    <ChatHistory
                        url={AttendanceService.getChat(id)}
                        title=""
                        height="h-[520px]"
                        dataCallback={(response) => setStatus(response?.status)}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default AttendanceChatCard;
